import { AddAdminMutation } from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

export const addAdminMutationHandler = graphql.mutation<AddAdminMutation>(
  "addAdmin",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        addAdmin: {
          result: true,
        },
      },
    });
  }
);
